import { FC } from 'react';
import MenuItem from '@/components/menu/menu-item';
import useCopyWithToast from '@/hooks/use-copy-with-toast.hook';
import { IconType } from '../icon/helpers';

interface Props {
  value: string;
  label: string;
  subtitle?: string;
  icon: IconType;
}

const CopyMenuItem: FC<Props> = ({ value, label, subtitle, icon }) => {
  const copy = useCopyWithToast();
  return <MenuItem label={label} subtitle={subtitle} icon={icon} onClick={() => copy(value)} />;
};

export default CopyMenuItem;
